"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownMenuDivider;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropdownMenuDivider() {
  return _react2.default.createElement("li", { className: "divider", role: "presentation" });
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-menu/components/DropdownMenuDivider.component.js
// module id = 625
// module chunks = 0 1 9 10 11